// components/StepIndicator.js
import React from 'react';

const StepIndicator = ({ currentStep, language, t }) => {
  const steps = [
    { number: 1, label: t?.step1 || 'Dates' },
    { number: 2, label: t?.step2 || 'Chambre' },
    { number: 3, label: t?.step3 || 'Options' },
    { number: 4, label: t?.step4 || 'Informations' },
    { number: 5, label: t?.step5 || 'Paiement' }
  ];

  return (
    <div className="flex justify-center mb-12">
      <div className="flex items-center space-x-4 lg:space-x-8">
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <div className={`flex items-center ${currentStep >= step.number ? 'text-black' : 'text-gray-400'}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 
                ${currentStep >= step.number ? 'border-black bg-black text-white' : 'border-gray-400'}`}>
                {step.number}
              </div>
              <span className="ml-2 text-sm uppercase tracking-wider hidden sm:inline">{step.label}</span>
            </div>
            {index < steps.length - 1 && (
              <div className="hidden lg:block">
                <div className={`h-0.5 w-16 ${currentStep > step.number ? 'bg-black' : 'bg-gray-300'}`}></div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;